import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { displayCreationModal } from 'saas/contacts/modals';
import { connect } from 'react-redux';
import { addContact, selectContact } from '../actions/contacts';
import { getContacts } from '../reducers/contacts';
import { getSites } from '../reducers/sites';
import { getContactId, getSiteId, getErrors } from '../reducers/form';
import { Button, Form, Icon, Dropdown } from 'semantic-ui-react';

export class ContactSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this._onAddContact = this._onAddContact.bind(this);
  }

  _onAddContact(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const onSaved = this.props.onAdded;

    // Displaying contact modal
    displayCreationModal(this.props.customerId, onSaved);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  render() {
    const {
      sites,
      selectedSiteId,
      selectedContactId,
      contacts,
      readOnly,
    } = this.props;

    const selectedSite = sites.find(s => selectedSiteId === s.id);

    const filteredOptions = contacts
      .filter(
        c =>
          c.is_usable_as_contact_site === true &&
          (c.is_deleted === false || c.id === selectedContactId)
      )
      .map(c => {
        return {
          key: c.id,
          value: c.id,
          text: `${c.last_name} ${c.first_name}`,
        };
      });

    const valueWithDefault = () => {
      if (selectedContactId) return selectedContactId;
      else if (selectedSite && selectedSite.contact_id)
        return selectedSite.contact_id;
      else return undefined;
    };

    return (
      <Form.Field>
        <label>Contact site</label>
        <Form.Group>
          <Form.Field width={12} style={{ paddingRight: '0' }}>
            <Dropdown
              selection
              value={valueWithDefault()}
              options={filteredOptions}
              onChange={(_, o) => this.props.onSelected(o.value)}
              disabled={readOnly}
            />
          </Form.Field>
          <Form.Field style={{ paddingLeft: '0' }}>
            <Button
              icon
              onClick={() => this.props.onSelected(undefined)}
              disabled={readOnly}
            >
              <Icon name="close" />
            </Button>
          </Form.Field>
          <Form.Field>
            <Button
              icon
              labelPosition="left"
              onClick={this._onAddContact}
              disabled={readOnly}
            >
              <Icon name="add" />
              Créer
            </Button>
          </Form.Field>
        </Form.Group>
      </Form.Field>
    );
  }
}

ContactSelector.propTypes = {
  sites: PropTypes.array.isRequired,
  selectedSiteId: PropTypes.number, //TODO set required
  contacts: PropTypes.array.isRequired,
  selectedContactId: PropTypes.number, //TODO set required
  onAdded: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  errors: PropTypes.array.isRequired,
  customerId: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  sites: getSites(state),
  selectedSiteId: getSiteId(state),
  contacts: getContacts(state),
  selectedContactId: getContactId(state),
  errors: getErrors(state),
});

const mapDispatchToProps = dispatch => ({
  onSelected: contact => dispatch(selectContact(contact)),
  onAdded: contact => dispatch(addContact(contact)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactSelector);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/ContactSelector.js